import React, { useEffect, useRef } from "react";
import { openAlert } from "simple-react-alert";

const Audio = ({ active, notify, negocio }) => {
    const audioRef = useRef(null);
    const timerRef = useRef(null);    

    useEffect(() => {
        try {
        if (active) {
            const audio = audioRef.current;
            if (audio) {
                audio.play();
            }
        } else {
            // If active becomes false, stop the audio immediately
            const audio = audioRef.current;
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        }
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    } catch {
        openAlert({
            message: "Tenes un nuevo evento en el dashboard",
            type: "info",
            duration: 5000
        })
    }
    }, [active]);

    return (
        <div>
            <audio ref={audioRef} src="/notify.mp3" loop />
        </div>
    );
};

export default Audio;
